export default {
  allDay: 'Cały dzień',
};
